import type { CustomOptionGroup } from "../api/products";

export const STICKER_MATERIAL_LIBRARY = "STICKER_MATERIAL";

function configRecord(config: unknown): Record<string, unknown> {
  return config !== null && typeof config === "object" && !Array.isArray(config)
    ? config as Record<string, unknown> : {};
}

export function isSharedStickerMaterial(group: Pick<CustomOptionGroup, "config">): boolean {
  return configRecord(group.config).sharedMaterialLibrary === STICKER_MATERIAL_LIBRARY;
}

export function stickerMaterialConfig(config: unknown, linked: boolean): Record<string, unknown> | null {
  const next = { ...configRecord(config) };
  if (linked) next.sharedMaterialLibrary = STICKER_MATERIAL_LIBRARY;
  else delete next.sharedMaterialLibrary;
  return Object.keys(next).length ? next : null;
}
